module.exports = __webpack_public_path__ + "static/media/bg_product.e6f56102.png";